import apiClient from '../connections/api'

const getPermissions = () => {
    return apiClient.get('/permissions')
}

export default {
    getPermissions
}
